angular.module('dnecom')
    .controller('ProductProcessCategoryController', ["$scope", "wizardModal", function ProductProcessCategoryController($scope, wizardModal) {
        $scope.productCategories = angular.copy(TemplateData.value('categories'));
        $scope.categoryId = $scope.product.category ? $scope.product.category.id : null;
        $scope.touched = false;

        $scope.onCategorySelect = function($item) {
            $scope.product.category = $item ? angular.copy($item) : null;
            propagateCategoryUpdated();
        };

        $scope.$on('product.afterSave', function (event, data) {
            if (!data.product.category) {
                return;
            }
            var category = $scope.productCategories.find(function (item) {
                return item.id === data.product.category.id;
            });
            if (!category) {
                $scope.productCategories = $scope.productCategories.filter(function (item) {
                    return item.id !== null;
                });

                $scope.productCategories.unshift(data.product.category);
            }
        });

        $scope.$on('product.touchPartials', function (event, data) {
            $scope.touched = true;
        });

        $scope.getProductCategoriesForSelector = function (search) {
            if (search) {
                var category = $scope.productCategories.find(function (item) {
                    return item.name === search;
                });
                if (!category) {
                    $scope.productCategories = $scope.productCategories.filter(function (item) {
                        return item.id !== null;
                    });

                    $scope.productCategories.unshift({id: null, name: search});
                }
            }

            return $scope.productCategories;
        };

        $scope.$watch('product.status', function(newValue, oldValue) {
            if (newValue == "draft") {
                propagateCategoryUpdated();
            }
        });

        function propagateCategoryUpdated() {
            $scope.onFieldUpdate('category');
            $scope.onFieldUpdate('category.googleProductCategory');
        }

        $scope.selectGoogleCategory = function() {
            var modal = wizardModal.open({
                'templateUrl': 'selectGoogleProductCategory.html',
                'size': 'md',
                'controller': 'ProductProcessGoogleProductCategoryController',
                'resolve': {
                    'currentGoogleProductCategory': function () {
                        return $scope.product.googleProductCategory;
                    }
                }
            });

            modal.result.then(function (googleProductCategory) {
                $scope.product.googleProductCategory = googleProductCategory;
                propagateCategoryUpdated();
            });
        };

    }]);
